import "material-icons/iconfont/material-icons.css";
import React, { useEffect, useState, useRef } from "react";
import Link from "components/Link";
import { usePathname, useRouter } from "components/Navigation";
import { checkNotAuthorized, getStorage, getStorageParse } from "pages/Utils";
import BtnIconAct from "components/BtnIconAct";
import { api_services } from "hooks/api_services";
import BadgeLabel from "components/BadgeLabel";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Input from "components/Input";
import Dropdown from "react-bootstrap/Dropdown";
import Overlay from "react-bootstrap/Overlay";
import Tooltip from "react-bootstrap/Tooltip";
import $ from "jquery";
import FormTextArea from "components/FormTextArea";
import { useSelector, useDispatch } from "react-redux";
import {
  VAR_IS_PAGE_READONLY,
  VAR_SET_BREADCRUMBS,
  VAR_SET_BREADCRUMBS_COUNTER,
  VAR_SET_REGISTER_ITEM,
} from "hooks/redux";

const SidebarRisikoDetail = (props) => {
  const router = useRouter();
  const {
    getapi_services,
    getapi_servicesid,
    postapi_services,
    putapi_services,
    deleteapi_services,
  } = api_services({
    api_path: `/risk_register`,
  });
  const dispatch = useDispatch();
  const pathname = usePathname();
  const [data_menu, setdata_menu] = useState([]);
  const breadcrumbsCounter = useSelector((state) => state.breadcrumbsCounter);
  const [menu_clicked, setmenu_clicked] = useState(0);
  const [init_menu, setinit_menu] = useState(false);
  const [page_active, setpage_active] = useState("");
  const [page_path, setpage_path] = useState("");
  const [show_dropdown, setshow_dropdown] = useState(false);
  const [id, setid] = useState(null);
  const [id_profile, setid_profile] = useState(null);
  const [is_risk_profile, setis_risk_profile] = useState(false);

  const [errors, setErrors] = useState({});

  const [is_loading, setis_loading] = useState("");
  const [nama, setnama] = useState("");
  const [nama_assessment_type, setnama_assessment_type] = useState("");
  const [nama_kelompok_bisnis, setnama_kelompok_bisnis] = useState("");
  const [nama_unit, setnama_unit] = useState("");
  const [nama_status_pengajuan, setnama_status_pengajuan] = useState("");
  const [warna, setwarna] = useState("");
  const [id_status_pengajuan, setid_status_pengajuan] = useState("");
  const [nama_owner, setnama_owner] = useState("");
  const [btnajukan, setajukan] = useState(null);
  const [btnkembalikan, setkembalikan] = useState(null);
  const [disablearr, setdisablearr] = useState([]);
  const [jenisajuan, setjenisajuan] = useState(1);
  const [history_pengajuan, sethistory_pengajuan] = useState([]);
  const [history_pengajuan_show, sethistory_pengajuan_show] = useState(false);

  const initialized = useRef(false);

  const [modalajukan, setmodalajukan] = useState(false);
  const [message_input, setmessage_input] = useState("");
  // const statuspengajuan = {
  //     1: "Ajukan Risk Limit",
  //     2: "Teruskan Ajuan Risk Limit",
  //     3: "Teruskan Ajuan Risk Limit",
  //     4: "Teruskan Ajuan Risk Limit",
  //     6: "Ajukan BK1 sd BK6",
  //     5: null,
  //     7: "Teruskan Ajuan BK1 sd BK6",
  //     8: "Teruskan Ajuan BK1 sd BK6",
  //     9: "Teruskan Ajuan BK1 sd BK6",
  //     10: null,
  //     11: "Ajukan BK7 sd BK10",
  //     12: "Teruskan Ajuan BK7 sd BK10",
  //     13: "Teruskan Ajuan BK7 sd BK10",
  //     14: "Teruskan Ajuan BK7 sd BK10",
  //     15: null,
  //     16: null,
  //     17: null,
  // };

  const [datamenu, setdatamenu] = useState([
    // {
    //     "page": "risk_metrik_strategi_risiko",
    //     "label": "Metrik Strategi Risiko"
    // },
    // {
    //     "page": "risk_sasaran",
    //     "label": "Sasaran & Strategi Bisnis"
    // },
    // {
    //     "page": "risk_capacity_limit",
    //     "label": "Risk Capacity & Risk Appetite"
    // },
    {
      page: "risk_profile",
      label: "Risk Profile",
    },
    {
      page: "risk_profile_analisa_risiko_inheren",
      label: "Analisa Risiko Inheren",
    },
    {
      page: "risk_profile_analisa_risiko_residual",
      label: "Analisa Risiko Residual",
    },
    {
      page: "risk_profile_rencana_perlakuan_risiko",
      label: "Rencana Perlakuan Risiko",
    },
    {
      page: "risk_profile_realisasi_risiko_residual",
      label: "Realisasi Risiko Residual",
    },
    {
      page: "risk_profile_realisasi_pelaksanaan_perlakuan_risiko_dan_biaya",
      label: "Realisasi Pelaksanaan Perlakuan Risiko dan Biaya",
    },
    {
      page: "lost_event",
      label: "Lost Event",
    },
    // {
    //     "page": "internal_control_testing",
    //     "label": "Internal Control Testing"
    // }
  ]);

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
    }
    if (true) {
      initId();
    }
  }, [pathname]);

  const initId = () => {
    const path_arr = ["add", "edit", "detail"];
    const pathname_arr = pathname.split("/");

    const page = pathname_arr[1];
    const id = pathname_arr[4];

    // // console.log('pathname_arr')
    // // console.log(pathname_arr)

    let path = "";
    let path_ready = false;
    for (let i = 0; i < path_arr.length; i++) {
      if (path_arr[i] == pathname_arr[3]) {
        path_ready = true;
        path = pathname_arr[3];
      }
    }

    setpage_active(page);
    setid(id);

    // // console.log('PATH=>')
    // // console.log(pathname_arr)
    // // console.log(pathname_arr[pathname_arr.length - 1])
    // // console.log(path_ready)
    // // console.log(path)
    // // console.log(id)

    // if (path_ready) {
    //     setpage_path(path)
    //     if (path == 'edit') {
    //         setid_profile(pathname_arr[4])
    //     }
    // } else {
    //     setpage_path('')
    //     setid_profile(null)
    // }

    // handlegetrisk_registerid(id)
    handlegetrisk_profileid(id);
  };

  const handlegetrisk_profileid = async (id) => {
    // // console.log('handlegetrisk_profileid')
    // // console.log(path_param)
    // if (!id_profile) return
    // if (path_param != 'edit' && path_param != 'detail') return

    setis_loading(true);
    const response = await getapi_servicesid({ api_path: `/risk_profile`, id });
    // // console.log('getrisk_profileid=>sidebar')
    // // console.log(response)
    if (!response.error || response.error.message != "canceled")
      setis_loading(false);

    checkNotAuthorized(response);

    if (response.error || response.code) return;

    // setsasaran(response.sasaran)
    // setid_sasaran(response.id_sasaran)
    // setnilai_sasaran(response.nilai_sasaran)
    // setid_jenis_risiko(response.id_jenis_risiko)
    // setid_taksonomi(response.id_taksonomi)

    // setnama(response.nama)
    // setdeskripsi(response.deskripsi)
    // setis_kuantitatif(response.is_kuantitatif)
    // settgl_risiko(response.tgl_risiko)
    // setid_kriteria_dampak(response.id_kriteria_dampak)
    // setid_risk_agregasi_risiko(response.id_risk_agregasi_risiko)

    // setid_risiko({ label: response.nama, value: response.id_risiko })
    // let id_penyebab = []
    // response.penyebab.map(m => {
    //     id_penyebab.push({
    //         label: m.nama,
    //         value: m.id_penyebab,
    //         id_profile_penyebab: m.id_profile_penyebab,
    //     })
    // })
    // setid_penyebab(id_penyebab)

    // setkri_kualitatif(response.kri_kualitatif)
    // setkri_kuantitatif(response.kri_kuantitatif)

    // let kri_new = [...response.kri_kualitatif, ...response.kri_kuantitatif]
    // setkri_new(kri_new)

    // setexisting_control(response.control)
    // setdampak(response.dampak)
  };

  const handlegetrisk_registerid = async (id) => {
    if (!id) return;

    setis_loading(true);
    const response = await getapi_servicesid({
      setErrors,
      api_path: `/risk_register/getdetail`,
      id,
    });
    // // console.log('getrisk_registerid=>sidebar')
    // // console.log(response)
    if (!response.error || response.error.message != "canceled")
      setis_loading(false);

    checkNotAuthorized(response);

    if (response.error || response.code) return;

    setnama(response.nama);
    setnama_assessment_type(response.nama_assessment_type);
    setnama_kelompok_bisnis(response.nama_kelompok_bisnis);
    setnama_unit(response.nama_unit);
    setnama_status_pengajuan(response.nama_status_pengajuan);
    setwarna(response.warna);
    setid_status_pengajuan(response.id_status_pengajuan);
    setdisablearr(response.page_disable);
    setajukan("");
    setkembalikan("");
    if (response.button) {
      if (response.button.ajukan) setajukan(response.button.ajukan);
      if (response.button.kembalikan) setkembalikan(response.button.kembalikan);
    }
    setnama_owner(response.nama_owner);
    sethistory_pengajuan(response.history_pengajuan);

    let is_page_readonly = false;
    const pathname_arr = pathname.split("/");
    const page = pathname_arr[1];
    if (response.page_read_only) {
      for (let i = 0; i < response.page_read_only.length; i++) {
        if (response.page_read_only[i] == page) {
          is_page_readonly = true;
          break;
        }
      }
    }
    // // console.log('is_page_readonly')
    // // console.log(is_page_readonly)
    dispatch({
      type: VAR_IS_PAGE_READONLY,
      value: is_page_readonly,
    });
    dispatch({
      type: VAR_SET_REGISTER_ITEM,
      value: response,
    });
    dispatch({
      type: VAR_SET_BREADCRUMBS,
      value: response.parent,
    });
    dispatch({
      type: VAR_SET_BREADCRUMBS_COUNTER,
      value: breadcrumbsCounter + 1,
    });
  };

  const handleAjukan = async () => {
    if (!id) return;
    setis_loading(true);
    const response = await postapi_services({
      setErrors,
      id_register: id,
      msg: message_input,
      api_path: `/risk_register/ajukan/` + jenisajuan,
    });

    // console.log("getrisk_registerid=>sidebar");
    // console.log(response);
    if (!response.error || response.error.message != "canceled")
      setis_loading(false);

    checkNotAuthorized(response);

    if (response.error || response.code) return;
    handlegetrisk_registerid(id);
    handleAjukanHide();
    setmessage_input("");
  };

  const handledeleterisk_register = async () => {
    // router.push('/risk_register')
    // return
    const response = await deleteapi_services({ setErrors, id });
    // // console.log('deleterisk_register')
    // // console.log(response)

    checkNotAuthorized(response);
    if (response.error || response.code) return;

    router.push("/risk_register");
  };

  const initMenu = async () => {};

  const resInitMenuTree = (data) => {
    initMenuTree(data);
    return data;
  };

  const initMenuTree = (data) => {
    data.forEach((m) => {
      const pathname_arr = pathname.split("/");
      const page = pathname_arr[1];
      m.active = `${m.page}` === page ? true : false;
      if (init_menu) {
        m.collapsed = m.collapsed;
      } else {
        m.collapsed = true;
      }

      if (m.submenu && m.submenu.length > 0) {
        initMenuTree(m.submenu);
      }
    });
  };

  const initMenuActive = () => {
    setmenu_clicked(menu_clicked + 1);
    let menu = resInitMenuTree(data_menu);
    setdata_menu(menu);

    // const menu_active = func_menu_active(menu)
    // menu.forEach(m => {

    // })
  };

  const func_menu_active = (data) => {
    data.forEach((m) => {
      if (m.active) {
        return m;
      }
      if (m.submenu && m.submenu.length > 0) {
        func_menu_active(m.submenu);
      }
    });
  };

  const handleClickMenu = (item_menu) => {
    setmenu_clicked(menu_clicked + 1);

    const data_menu_res = func_data_menu_foreach(data_menu, item_menu);
    setdata_menu(data_menu_res);
  };

  const func_data_menu_foreach = (data_menu, item_menu) => {
    data_menu_foreach(data_menu, item_menu);
    return data_menu;
  };

  const data_menu_foreach = (data_menu, item_menu) => {
    return data_menu.forEach((m, i) => {
      if (m.page === item_menu.page) {
        m.collapsed = m.collapsed ? false : true;
      }
      if (m.submenu !== undefined && m.submenu.length > 0) {
        data_menu_foreach(m.submenu, item_menu);
      }
    });
  };

  const handleAjukanShow = (jenis) => {
    // // console.log('jenis')
    // // console.log(jenis)
    setjenisajuan(jenis);
    setmodalajukan(true);
  };
  const handleAjukanHide = () => {
    setmodalajukan(false);
  };

  const handleErrors = () => {};

  return (
    <>
      <div className="header-sidebar-risiko">
        <div className="flex">
          <div className="flex-1" style={{ paddingTop: 10 }}>
            <div className="title-risiko">
              {is_loading ? "Loading..." : nama}
            </div>
          </div>
          <div className="d-flex">
            {/* <BtnIconAct icon="edit" href="/" />
                        <BtnIconAct icon="delete" href="/" /> */}

            <div className="relative inline-block text-left">
              {/* <div>
                                <button type="button" onClick={() => setshow_dropdown(!show_dropdown)} className="inline-flex w-full justify-center gap-x-1.5 rounded-md px-3 py-2 text-sm font-semibold text-gray-900 unset-border" id="menu-button" aria-expanded="true" aria-haspopup="true" style={{ paddingLeft: '0.5rem' }}>
                                    <span className="material-icons">more_vert</span>
                                </button>
                            </div>

                            {show_dropdown ? (
                                <div className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none shadow-strong-app" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
                                    <div className="py-1" role="none">

                                        <Link href={`/risk_register/edit/${id}`} className="text-gray-700 block px-4 py-2 text-sm" role="menuitem" tabindex="-1" id="menu-item-0">Edit Kajian Risiko</Link>
                                        <a href="#" onClick={() => {
                                            if (confirm('Yakin menghapus data ini?')) {
                                                handledeleterisk_register()
                                            }
                                        }} className="text-gray-700 block px-4 py-2 text-sm" role="menuitem" tabindex="-1" id="menu-item-1">Delete Kajian Risiko</a>
                                    </div>
                                </div>
                            ) : null} */}

              {/* <Dropdown>
                                <Dropdown.Toggle variant="" id="dropdown-basic">
                                    <span className='material-icons'>more_vert</span>
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Link href={`/risk_register/edit/${id}`} className='d-flex align-items-center link-edit'>
                                        <span className='material-icons' style={{ fontSize: 18, marginRight: 7 }}>edit</span> Edit Kajian Risiko
                                    </Link>
                                    <Dropdown.Item onClick={() => {
                                        if (confirm('Yakin menghapus data ini?')) {
                                            handledeleterisk_register()
                                        }
                                    }} className='d-flex align-items-center'>
                                        <span className='material-icons' style={{ fontSize: 18, marginRight: 7 }}>delete</span> Delete Kajian Risiko
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown> */}
            </div>
          </div>
        </div>

        {/* <div className='c-pemilik-risiko'>
                    <b style={{ fontSize: 11 }}>Pemilik Risiko:</b>
                    <div className="pemilik-risiko">
                        {nama_owner}
                    </div>
                    <b style={{ fontSize: 11 }}>Jenis Penilaian Risiko:</b>
                    <div className="pemilik-risiko">
                        {nama_assessment_type}
                    </div>
                    <b style={{ fontSize: 11 }}>Kelompok Bisnis:</b>
                    <div className="pemilik-risiko">
                        {nama_kelompok_bisnis}
                    </div>
                    <b style={{ fontSize: 11 }}>Unit:</b>
                    <div className="pemilik-risiko">
                        {nama_unit}
                    </div>
                </div> */}
      </div>

      <ul className="sidebar-ul">
        {datamenu.map((v, i) => (
          <li className={`sidebar-li`} key={i}>
            <ItemMenu
              disabled={disablearr.includes(v.page)}
              className={`sidebar-a ${page_active == v.page ? "active" : ""}`}
              label={v.label}
              icon={"descriptions"}
              href={`/${v.page}/${id}`}
            />
          </li>
        ))}
      </ul>

      <div className="container-sidebar-bottom">
        {btnkembalikan ? (
          <BtnIconAct
            className="btn-danger mb-1"
            icon="chevron_left"
            label={btnkembalikan}
            onTap={() => {
              handleAjukanShow(-1);
            }}
          />
        ) : null}
        {btnajukan ? (
          <BtnIconAct
            className="btn-warning mb-1"
            icon="chevron_right"
            right
            label={btnajukan}
            onTap={() => {
              handleAjukanShow(1);
            }}
            abaikan_is_page_readonly
          />
        ) : null}

        {/* <div className='flex justify-between items-center'>
                    <BadgeLabel
                        style={{ backgroundColor: `${warna}`, color: "#000" }}
                        label={nama_status_pengajuan} />

                    <BtnIconAct
                        className=""
                        icon="info"
                        classNameColorText="color-black"
                        tooltips="Riwayat Pengajuan"
                        onTap={() => sethistory_pengajuan_show(!history_pengajuan_show)}
                        abaikan_is_page_readonly
                    />
                </div> */}

        {/* <div className='c-pemilik-risiko'>
                    <b style={{ fontSize: 12 }}>Status Risiko:</b>
                    <BadgeLabel className="bg-warning" label="Open" />
                </div> */}

        {/* {history_pengajuan_show ? history_pengajuan.map((m, i) => (
                    <div key={i}>
                        <b>{m.id_group}</b>
                        <div>{m.msg}</div>
                        <div className='date-time-hp'>{m.created_at}</div>
                        <hr className='hr' />
                    </div>
                )) : null} */}
      </div>

      {/* <Modal show={modalajukan} onHide={handleAjukanHide}>
                <Modal.Header closeButton>
                    <Modal.Title>{jenisajuan == 1 ? "Ajukan" : "Kembalikan"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <FormTextArea
                        edited="true"
                        style={{ width: "100%" }}
                        ref={null}
                        id='message_input'
                        type='textarea'
                        label={''}
                        placeholder={'Catatan...'}
                        value={message_input}
                        className='block mt-1 w-full'
                        onChange={event => setmessage_input(event.target.value)}
                        required={true}
                        autoFocus
                        message_error={errors.message_input}
                        onError={handleErrors}
                        disabled={false}
                    // formOnly
                    />

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleAjukanHide}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={() => { handleAjukan() }}>
                        {jenisajuan == 1 ? "Ajukan" : "Kembalikan"}
                    </Button>
                </Modal.Footer>
            </Modal> */}
    </>
  );
};

export default SidebarRisikoDetail;

const ItemMenu = (propsx) => {
  const [show, setShow] = useState(false);
  const target = useRef(null);

  const handleShow = () => {
    if (checksidebar_collapsed()) {
      setShow(true);
    }
  };
  const handleHide = () => {
    if (checksidebar_collapsed()) {
      setShow(false);
    }
  };

  const checksidebar_collapsed = () => {
    // // console.log('initsidebar_collapsed')
    const body_classname = $("body").attr("class");
    // // console.log('body_classname')
    // // console.log(body_classname.attr('class'))

    if (body_classname.includes("sidebar-collapsed")) {
      return true;
    }
    return false;
  };

  return (
    <>
      {/* <Link
                ref={target}
                href={propsx.children_exists ? "#" : `/${propsx.page}`}
                className={`sidebar-a ${propsx.active ? 'active' : ''} ${propsx.children_exists ? "children-exists" : ""}`}
                onClick={() => propsx.children_exists ? propsx.onClickMenu(propsx.data) : null}
                onMouseEnter={handleShow}
                onMouseLeave={handleHide}
            >
                {propsx.icon ? <span className="material-icons">{propsx.icon}</span> : null}
                <span className='sidebar-a-label'>{propsx.label}</span>
            </Link> */}
      {propsx.disabled ? (
        <div className={propsx.className}>
          <span className="material-icons">{propsx.icon}</span>
          <span className="sidebar-a-label">{propsx.label}</span>
        </div>
      ) : (
        <Link
          ref={target}
          href={propsx.href}
          className={propsx.className}
          onMouseEnter={handleShow}
          onMouseLeave={handleHide}
        >
          <span className="material-icons">{propsx.icon}</span>
          <span className="sidebar-a-label">{propsx.label}</span>
        </Link>
      )}
      <Overlay target={target.current} show={show} placement="right">
        {(props) => (
          <Tooltip id={propsx.href} {...props}>
            {propsx.label}
          </Tooltip>
        )}
      </Overlay>
    </>
  );
};
